// extracted by mini-css-extract-plugin
export const container = "photoChild-module--container--h4sG4";
export const element = "photoChild-module--element--2OCur";
export const row = "photoChild-module--row--1pXcr";
export const image = "photoChild-module--image--2liRv";